module.exports = __webpack_public_path__ + "static/media/logo.ba500a0d.png";